module.exports = __webpack_public_path__ + "static/img/product-ADHD-RS-5(CN).82c0a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product-ADHD-RS-5(CN).png
// module id = aKhx
// module chunks = 13